import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4">
          <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center rounded-full bg-background-100">
            <i className="ri-emotion-unhappy-line text-4xl text-foreground-300"></i>
          </div>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 mb-3">
            404
          </h1>
          <h2 className="text-lg md:text-xl font-semibold text-foreground-800 mb-2">
            页面未找到
          </h2>
          <p className="text-sm text-foreground-500 mb-2">
            您访问的路径不存在或已被移除
          </p>
          <p className="text-xs text-foreground-400 font-mono mb-8">{location.pathname}</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-line"></i>
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}